import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

interface Props {
  label: string;
  statusText: string;
}

export const InsuranceStatusBox = ({ label, statusText }: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.statusRow}>
      <Typography className={classes.statusLabel}>{label}:</Typography>
      <Chip size="small" label={statusText} variant="outlined" className={classes.statusChip} />
    </Box>
  );
};

const useStyles = makeStyles({
  statusRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  statusLabel: {
    fontSize: '12px',
    color: '#6b7280',
  },
  statusChip: {
    backgroundColor: '#f8fafc',
  },
});
